import {call, put, take, takeLatest} from 'redux-saga/effects'
import {
  CLOSE_ONBOARDING,
  setStepLogin,
  setStepRegistration,
  openOnboarding,
} from '../components/Onboarding/redux/actions'
import {
  GET_PARTICIPANT_INFO,
  GET_PARTICIPANT_INFO_SUCCESS,
  clearParticipantInfo,
  getParticipantInfoFailure,
  getParticipantInfoPending,
  getParticipantInfoSuccess,
} from '../actions/api'
import * as peopleActions from '../actions/people'
import {logout} from '../actions/user'
import {openErrorModal} from '../actions/userInteractions'
import * as api from '../api/api'
import {BadResponse} from '../exceptions'

function* getParticipantInfoWorker({payload}) {
  try {
    yield put(getParticipantInfoPending())
    // less cases to handle if we make sure the user is logged out
    yield put(logout())
    const participant = yield api.getParticipantInfo(payload.token).then(
      api.onStatus({
        OK: ({json}) => json,
        404: () => {
          throw new Error('Token could not be found.')
        },
        DEFAULT: () => {
          throw new BadResponse()
        },
      }),
    )

    yield put(getParticipantInfoSuccess(participant))
  } catch (e) {
    console.error(`Could not retrieve participant info. Reason: ${e.message}`)
    yield put(openErrorModal())
    yield put(getParticipantInfoFailure(e))
  }
}

export function* getParticipantInfoSaga() {
  yield takeLatest(GET_PARTICIPANT_INFO, getParticipantInfoWorker)
}

function* onboardParticipantWorker({payload: {accountCreated}}) {
  // First, check to see if participant already has account or not
  // Set Onboarding to open at either Login or Registration step
  if (accountCreated) {
    yield put(setStepLogin())
  } else {
    yield put(setStepRegistration())
  }

  yield put(openOnboarding())

  yield take(CLOSE_ONBOARDING)
  yield put(clearParticipantInfo())
}

export function* onboardParticipantSaga() {
  yield takeLatest(GET_PARTICIPANT_INFO_SUCCESS, onboardParticipantWorker)
}

/**
 * Updates the name of the currently viewed look in the dashboard
 * @generator
 */
export function* updateIsOwnerWearingLookWorker({payload: {lookId, isWearing}}) {
  try {
    yield put(peopleActions.updateIsOwnerWearingLookPending())

    const response = yield call(api.ownerWearingLook, lookId, {event_owner_wears: isWearing})

    api.onStatus({
      OK: ({json}) => json,
      403: ({statusText}) => {
        throw new Error(`CSRF Token Invalid: ${statusText}`)
      },
      DEFAULT: ({statusText}) => {
        throw new Error(`Could not update isOwnerWearingLook: ${statusText}`)
      },
    })(response)

    yield put(
      peopleActions.updateIsOwnerWearingLookSuccess({lookId, isOwnerWearingLook: isWearing}),
    )
  } catch (e) {
    yield put(peopleActions.updateIsOwnerWearingLookFailure(e))
  }
}

export function* updateIsOwnerWearingLookSaga() {
  yield takeLatest(peopleActions.UPDATE_IS_OWNER_WEARING_LOOK, updateIsOwnerWearingLookWorker)
}
